module.exports = __webpack_public_path__ + "img/bg-title.e78692c1.png";